export default __webpack_public_path__ + "static/media/eindexEvolution.d3c17742.png";